import { useTranslate } from "ra-core";

import { StatusPill } from "../design/StatusPill";
import type { Expense } from "./expenseTypes";

/** "Cancelado" chip: red with a cross icon and text (never colour alone). */
export const CancelledChip = () => {
  const translate = useTranslate();
  return (
    <StatusPill tone="not-ok" text={translate("crm.expenses.cancelled")} />
  );
};

/** Binary invoiced indicator: green check "Facturado" / red cross "Sin factura". */
export const InvoicedPill = ({ invoiced }: { invoiced: boolean }) => {
  const translate = useTranslate();
  return (
    <StatusPill
      tone={invoiced ? "ok" : "not-ok"}
      text={translate(
        invoiced ? "crm.expenses.invoiced_yes" : "crm.expenses.invoiced_no",
      )}
    />
  );
};

/** Who paid: the free-text name when "Otro", the translated payer otherwise. */
export const usePaidByLabel = () => {
  const translate = useTranslate();
  return (expense: Pick<Expense, "paid_by" | "paid_by_other">): string =>
    expense.paid_by === "otro" && expense.paid_by_other
      ? expense.paid_by_other
      : translate(`crm.expenses.paid_by_values.${expense.paid_by}`);
};
